import React from 'react';
import { Wallet, CreditCard } from 'lucide-react';
import { getAgentBalanceDisplay } from '../../utils/agentPaymentNav';

const formatInr = (amount) => `₹${Number(amount || 0).toLocaleString('en-IN')}`;

const AgentBalanceBadge = ({ agent, variant = 'compact', className = '' }) => {
  const display = getAgentBalanceDisplay(agent);

  if (variant === 'compact') {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        {display.showWallet && (
          <div
            className="flex items-center gap-1.5 bg-teal-500 px-3 py-1 rounded-full text-white"
            data-testid="agent-topbar-wallet-balance"
          >
            <Wallet size={14} />
            <span className="text-sm font-semibold">{formatInr(display.walletAmount)}</span>
          </div>
        )}
        {display.showCredit && (
          <div
            className="flex items-center gap-1.5 bg-[#1B375B] px-3 py-1 rounded-full text-white"
            data-testid="agent-topbar-credit-balance"
          >
            <CreditCard size={14} />
            <span className="text-sm font-semibold">{formatInr(display.creditAmount)}</span>
          </div>
        )}
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className={`p-4 m-4 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl border border-teal-100 ${className}`}>
        {display.showWallet && (
          <div className={display.showCredit ? 'mb-4 pb-4 border-b border-teal-100' : ''}>
            <div className="flex items-center justify-between mb-2">
              <p className="text-sm font-medium text-gray-700">{display.walletLabel}</p>
              <Wallet size={16} className="text-teal-600" />
            </div>
            <p
              className="text-2xl font-bold text-gray-900"
              data-testid="agent-topbar-wallet-balance"
            >
              {formatInr(display.walletAmount)}
            </p>
          </div>
        )}
        {display.showCredit && (
          <div>
            <div className="flex items-center justify-between mb-2">
              <p className="text-sm font-medium text-gray-700">{display.creditLabel}</p>
              <CreditCard size={16} className="text-[#1B375B]" />
            </div>
            <p
              className="text-2xl font-bold text-gray-900"
              data-testid="agent-topbar-credit-balance"
            >
              {formatInr(display.creditAmount)}
            </p>
          </div>
        )}
        <div className="mt-3 pt-3 border-t border-teal-100">
          <p className="text-xs font-semibold text-gray-700">{agent?.agency_name || ''}</p>
          <p className="text-xs text-gray-500">{agent?.full_name || ''}</p>
        </div>
      </div>
    );
  }

  return null;
};

export default AgentBalanceBadge;
